import { CheckCircle, DollarSign, Loader, ShoppingCart, XCircle } from 'lucide-react';

const topSellingProducts = [
  {
    id: 1,
    name: 'LED Bulb 12W',
    brand: 'Philips',
    category: 'Lighting',
    subCategory: 'Bulbs',
    sales: 300,
    orders: 120,
    month: 'Jan',
  },
  {
    id: 2,
    name: 'Ceiling Fan',
    brand: 'Havells',
    category: 'Appliances',
    subCategory: 'Fans',
    sales: 500,
    orders: 200,
    month: 'Feb',
  },
  {
    id: 3,
    name: 'Electric Kettle',
    brand: 'Usha',
    category: 'Appliances',
    subCategory: 'Kettles',
    sales: 150,
    orders: 75,
    month: 'Jan',
  },
  {
    id: 4,
    name: 'Tube Light 36W',
    brand: 'Crompton',
    category: 'Lighting',
    subCategory: 'Tubes',
    sales: 400,
    orders: 150,
    month: 'Mar',
  },
  {
    id: 5,
    name: 'Extension Cord',
    brand: 'Anchor',
    category: 'Accessories',
    subCategory: 'Cords',
    sales: 200,
    orders: 90,
    month: 'Feb',
  },
];

const dummyProducts = [
  'Office Sofa Set',
  'Gaming Chair Pro',
  'USB-C Hub Adapter',
  'Noise-Cancelling Earbuds',
  'Portable Monitor 15"',
  'Ergonomic Foot Rest',
  'Smart LED Lightstrip',
  'Wireless Charger Pad',
  '4K Webcam',
  'Adjustable Laptop Stand',
];

const mockLogs = [
  {
    productName: 'Premium Notebook',
    oldPrice: 299.99,
    newPrice: 349.99,
    changedBy: 'Admin John',
    changedAt: '2025-02-01',
  },
  {
    productName: 'Wireless Mouse',
    oldPrice: 599.99,
    newPrice: 499.99,
    changedBy: 'Admin Sarah',
    changedAt: '2025-01-10',
  },
  {
    productName: 'Bluetooth Speaker',
    oldPrice: 1299.0,
    newPrice: 1499.0,
    changedBy: 'Manager Alex',
    changedAt: '2025-04-20',
  },
  {
    productName: 'LED Monitor 24"',
    oldPrice: 8999.0,
    newPrice: 8599.0,
    changedBy: 'Admin Raj',
    changedAt: '2025-02-15',
  },
  {
    productName: 'Mechanical Keyboard',
    oldPrice: 2299.0,
    newPrice: 2499.0,
    changedBy: 'Admin Priya',
    changedAt: '2025-03-01',
  },
  {
    productName: 'USB-C Charger',
    oldPrice: 999.0,
    newPrice: 899.0,
    changedBy: 'Manager Neha',
    changedAt: '2025-03-18',
  },
  {
    productName: 'Webcam 1080p',
    oldPrice: 1999.0,
    newPrice: 2199.0,
    changedBy: 'Admin John',
    changedAt: '2025-04-01',
  },
  {
    productName: 'Ergonomic Chair',
    oldPrice: 7499.0,
    newPrice: 6999.0,
    changedBy: 'Manager Alex',
    changedAt: '2025-04-10',
  },
  {
    productName: 'Graphic Tablet',
    oldPrice: 4499.0,
    newPrice: 4799.0,
    changedBy: 'Admin Sarah',
    changedAt: '2025-04-22',
  },
  {
    productName: 'HDMI Cable 2m',
    oldPrice: 299.0,
    newPrice: 249.0,
    changedBy: 'Admin Priya',
    changedAt: '2025-04-25',
  },
];

const SellerNames = [
  'Sharma Traders',
  'Raj & Sons',
  'Kumar Electronics',
  'Mehta Mart',
  'Desi Fashion Hub',
  'Patel Handicrafts',
  'Bharat Essentials',
  'Choudhary Exports',
  'Mittal Appliances',
  'Verma Grocery Store',
  'Singh Textiles',
  'Gupta Electronics',
  'Joshi Saree Center',
  'Rao Spices & More',
  'Nair Home Needs',
];
const brandsMock = [
  { id: 1, name: 'Nike', marginPercentage: 10 },
  { id: 2, name: 'Adidas', marginPercentage: 12 },
  { id: 3, name: 'Puma', marginPercentage: 8 },
  { id: 4, name: 'Reebok', marginPercentage: 9 },
  { id: 5, name: 'Under Armour', marginPercentage: 11 },
  { id: 6, name: 'New Balance', marginPercentage: 10 },
  { id: 7, name: 'ASICS', marginPercentage: 7 },
  { id: 8, name: 'Skechers', marginPercentage: 6 },
  { id: 9, name: 'Fila', marginPercentage: 9 },
  { id: 10, name: 'Converse', marginPercentage: 8 },
  { id: 11, name: "Levi's", marginPercentage: 10 },
  { id: 12, name: 'Zara', marginPercentage: 13 },
  { id: 13, name: 'H&M', marginPercentage: 14 },
  { id: 14, name: 'Uniqlo', marginPercentage: 10 },
  { id: 15, name: 'Gucci', marginPercentage: 20 },
];

const dummyTopProducts = [
  { id: 1, name: 'Smartphone X', finalPrice: 16500.0, sold: 67 },
  { id: 2, name: 'Wireless Earbuds', finalPrice: 2200.0, sold: 51 },
  { id: 3, name: 'Casual T-Shirt', finalPrice: 880.0, sold: 72 },
  { id: 4, name: 'Fitness Tracker', finalPrice: 3850.0, sold: 13 },
  { id: 5, name: 'Designer Watch', finalPrice: 5500.0, sold: 45 },
];
const statCards = [
  {
    title: 'Total Orders',
    value: '1,258',
    icon: <ShoppingCart size={24} />,
    trend: { value: 12, isPositive: true },
  },
  {
    title: 'Total Sales',
    value: '89,240',
    icon: <DollarSign size={24} />,
    trend: { value: 8, isPositive: true },
  },
];
const revenueY = ['50k', '40k', '30k', '20k', '10k', '0'];
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'];
const barHeights = [35, 42, 38, 50, 35, 55, 60];
const linePoints = '15,115 63,90 111,100 159,70 207,95 255,65 303,55';
const lineYCoords = [115, 90, 100, 70, 95, 65, 55];

const productColumns = [
  {
    header: 'Product',
    accessor: (row) => row.name || '—',
  },
  {
    header: 'Brand',
    accessor: (row) => row.brand || '—',
  },
  {
    header: 'Category',
    accessor: (row) => row.category || '—',
  },
  {
    header: 'Sub-category',
    accessor: (row) => row.subCategory || '—',
  },
  {
    header: 'Sales',
    accessor: (row) => (row.sales !== undefined ? row.sales.toLocaleString() : '0'),
  },
  {
    header: 'Orders',
    accessor: (row) => (row.orders !== undefined ? row.orders.toLocaleString() : '0'),
  },
];

const topProducts = [
  { name: 'Premium Ergonomic Chair', value: 126, percentage: 22 },
  { name: 'Adjustable Standing Desk', value: 87, percentage: 15 },
  { name: 'Wireless Bluetooth Headphones', value: 205, percentage: 36 },
  { name: 'Ergonomic Keyboard', value: 154, percentage: 27 },
];
const inventoryItemsData = [
  {
    id: '101',
    productName: 'Wireless Ergonomic Mouse',
    variant: 'Black',
    sku: 'WEM-BLK-101',
    stock: 5,
    maxStock: 200,
    unitPrice: 49.99,
    supplier: 'TechGear Co.',
    category: 'Computer Accessories',
    location: 'Warehouse C',
    lastRestocked: '2025-05-20',
    reorderPoint: 20,
    brand: 'LogiTech',
    color: 'Black',
    weight: '85g',
  },
  {
    id: '102',
    productName: 'LED Desk Lamp',
    variant: 'Silver',
    sku: 'LDL-SLV-102',
    stock: 0,
    maxStock: 75,
    unitPrice: 79.99,
    supplier: 'BrightLight Ltd.',
    category: 'Office Supplies',
    location: 'Warehouse A',
    lastRestocked: '2025-05-15',
    reorderPoint: 10,
    brand: 'BrightLite',
    color: 'Silver',
    weight: '1.5kg',
  },
  {
    id: '103',
    productName: '4K Ultra HD Monitor',
    variant: '27 inch',
    sku: 'UHD-27-103',
    stock: 1,
    maxStock: 30,
    unitPrice: 399.99,
    supplier: 'VisionTech Inc.',
    category: 'Electronics',
    location: 'Warehouse B',
    lastRestocked: '2025-05-18',
    reorderPoint: 5,
    brand: 'ViewMax',
    color: 'Black',
    weight: '4.3kg',
  },
  {
    id: '104',
    productName: 'Office Filing Cabinet',
    variant: '3 Drawer',
    sku: 'OFC-3D-104',
    stock: 15,
    maxStock: 60,
    unitPrice: 149.99,
    supplier: 'Storage Solutions',
    category: 'Office Furniture',
    location: 'Warehouse C',
    lastRestocked: '2025-05-22',
    reorderPoint: 8,
    brand: 'SafeStore',
    color: 'Gray',
    weight: '18kg',
  },
  {
    id: '105',
    productName: 'Noise Cancelling Headphones',
    variant: 'Over-Ear',
    sku: 'NCH-OE-105',
    stock: 25,
    maxStock: 100,
    unitPrice: 129.99,
    supplier: 'SoundPro Electronics',
    category: 'Electronics',
    location: 'Warehouse A',
    lastRestocked: '2025-05-21',
    reorderPoint: 12,
    brand: 'SoundMax',
    color: 'Black',
    weight: '300g',
  },
  {
    id: '106',
    productName: 'USB-C Hub Multiport Adapter',
    variant: '7-in-1',
    sku: 'USB-HUB-106',
    stock: 10,
    maxStock: 120,
    unitPrice: 59.99,
    supplier: 'TechGear Co.',
    category: 'Computer Accessories',
    location: 'Warehouse B',
    lastRestocked: '2025-05-19',
    reorderPoint: 15,
    brand: 'HubMaster',
    color: 'Space Gray',
    weight: '120g',
  },
  {
    id: '107',
    productName: 'Executive Leather Chair',
    variant: 'Brown',
    sku: 'ELC-BRN-107',
    stock: 100,
    maxStock: 40,
    unitPrice: 299.99,
    supplier: 'Luxury Furnishings',
    category: 'Office Furniture',
    location: 'Warehouse A',
    lastRestocked: '2025-05-23',
    reorderPoint: 6,
    brand: 'LuxComfort',
    color: 'Brown',
    weight: '25kg',
  },
  {
    id: '108',
    productName: 'Wireless Keyboard',
    variant: 'Compact',
    sku: 'WK-CPT-108',
    stock: 60,
    maxStock: 150,
    unitPrice: 69.99,
    supplier: 'KeyWorks',
    category: 'Computer Accessories',
    location: 'Warehouse C',
    lastRestocked: '2025-05-20',
    reorderPoint: 25,
    brand: 'KeyMaster',
    color: 'White',
    weight: '450g',
  },
  {
    id: '109',
    productName: 'High-Speed HDMI Cable',
    variant: '2 meters',
    sku: 'HDMI-2M-109',
    stock: 100,
    maxStock: 300,
    unitPrice: 12.99,
    supplier: 'CableTech',
    category: 'Electronics',
    location: 'Warehouse B',
    lastRestocked: '2025-05-22',
    reorderPoint: 50,
    brand: 'CablePro',
    color: 'Black',
    weight: '100g',
  },
  {
    id: '110',
    productName: 'Desktop Organizer',
    variant: 'Wooden',
    sku: 'DO-WD-110',
    stock: 40,
    maxStock: 80,
    unitPrice: 39.99,
    supplier: 'Office Essentials',
    category: 'Office Supplies',
    location: 'Warehouse A',
    lastRestocked: '2025-05-19',
    reorderPoint: 15,
    brand: 'OrganizeIt',
    color: 'Natural Wood',
    weight: '2.5kg',
  },
  {
    id: '111',
    productName: 'Portable Laptop Stand',
    variant: 'Aluminum',
    sku: 'PLS-AL-111',
    stock: 35,
    maxStock: 90,
    unitPrice: 89.99,
    supplier: 'TechGear Co.',
    category: 'Computer Accessories',
    location: 'Warehouse C',
    lastRestocked: '2025-05-21',
    reorderPoint: 18,
    brand: 'StandPro',
    color: 'Silver',
    weight: '1.2kg',
  },
  {
    id: '112',
    productName: 'Ballpoint Pens (Pack of 12)',
    variant: 'Blue Ink',
    sku: 'BP-12PK-112',
    stock: 150,
    maxStock: 500,
    unitPrice: 9.99,
    supplier: 'WriteWell',
    category: 'Office Supplies',
    location: 'Warehouse B',
    lastRestocked: '2025-05-20',
    reorderPoint: 100,
    brand: 'PenMaster',
    color: 'Blue',
    weight: '250g',
  },
  {
    id: '113',
    productName: 'Ergonomic Footrest',
    variant: 'Adjustable Height',
    sku: 'EFR-AH-113',
    stock: 20,
    maxStock: 70,
    unitPrice: 59.99,
    supplier: 'ComfortZone',
    category: 'Office Furniture',
    location: 'Warehouse A',
    lastRestocked: '2025-05-23',
    reorderPoint: 10,
    brand: 'ComfortPlus',
    color: 'Black',
    weight: '3.8kg',
  },
  {
    id: '114',
    productName: 'Smartphone Charging Dock',
    variant: 'Wireless',
    sku: 'SCD-WL-114',
    stock: 18,
    maxStock: 60,
    unitPrice: 49.99,
    supplier: 'ChargeTech',
    category: 'Electronics',
    location: 'Warehouse B',
    lastRestocked: '2025-05-18',
    reorderPoint: 8,
    brand: 'ChargePro',
    color: 'Black',
    weight: '500g',
  },
  {
    id: '115',
    productName: 'Sticky Notes (Pack of 5)',
    variant: 'Multi-color',
    sku: 'SN-5PK-115',
    stock: 200,
    maxStock: 600,
    unitPrice: 14.99,
    supplier: 'Office Essentials',
    category: 'Office Supplies',
    location: 'Warehouse C',
    lastRestocked: '2025-05-22',
    reorderPoint: 120,
    brand: 'NoteIt',
    color: 'Multi',
    weight: '400g',
  },
];
const ordersdata = [
  {
    id: '1',
    orderId: 'WO-78451',
    retailerName: 'Office Solutions Inc.',
    retailerEmail: 'orders@officesolutions.com',
    products: [
      {
        id: 'p1',
        name: 'Premium Ergonomic Chair',
        quantity: 2,
        price: 599.99,
        sku: 'PEC-BLK-001',
      },
      {
        id: 'p2',
        name: 'Adjustable Standing Desk',
        quantity: 1,
        price: 899.99,
        sku: 'ASD-WHT-140',
      },
    ],
    totalAmount: 2099.97,
    status: 'delivered',
    paymentStatus: 'paid',
    paymentMethod: 'Credit Card',
    shippingAddress: {
      street: '123 Business Ave',
      city: 'Chicago',
      state: 'IL',
      zip: '60601',
      country: 'USA',
    },
    specialInstructions: 'Please deliver during business hours (9 AM - 5 PM)',
    timestamps: {
      pending: '2025-06-10T10:00:00Z',
      processing: '2025-06-10T14:30:00Z',
      shipped: '2025-06-11T09:15:00Z',
      delivered: '2025-06-14T13:45:00Z',
    },
  },
  {
    id: '2',
    orderId: 'WO-78452',
    retailerName: 'Tech Gear Ltd.',
    retailerEmail: 'contact@techgear.com',
    products: [
      {
        id: 'p3',
        name: '4K UHD Monitor',
        quantity: 3,
        price: 349.99,
        sku: 'MON-4K-002',
      },
    ],
    totalAmount: 1049.97,
    status: 'processing',
    paymentStatus: 'paid',
    paymentMethod: 'PayPal',
    shippingAddress: {
      street: '789 Tech Blvd',
      city: 'San Francisco',
      state: 'CA',
      zip: '94105',
      country: 'USA',
    },
    specialInstructions: 'Call before delivery',
    timestamps: {
      pending: '2025-06-15T08:30:00Z',
      processing: '2025-06-15T12:00:00Z',
    },
  },
  {
    id: '3',
    orderId: 'WO-78453',
    retailerName: 'Home Essentials',
    retailerEmail: 'sales@homeessentials.com',
    products: [
      {
        id: 'p4',
        name: 'Smart LED Bulbs (Pack of 10)',
        quantity: 1,
        price: 129.99,
        sku: 'SLB-10PK-003',
      },
    ],
    totalAmount: 129.99,
    status: 'pending',
    paymentStatus: 'unpaid',
    paymentMethod: 'Cash on Delivery',
    shippingAddress: {
      street: '456 Cozy St',
      city: 'Austin',
      state: 'TX',
      zip: '73301',
      country: 'USA',
    },
    specialInstructions: '',
    timestamps: {
      pending: '2025-06-17T09:45:00Z',
    },
  },
  {
    id: '4',
    orderId: 'WO-78454',
    retailerName: 'Elite Office Supplies',
    retailerEmail: 'orders@eliteoffice.com',
    products: [
      {
        id: 'p5',
        name: 'Conference Room Projector',
        quantity: 1,
        price: 799.99,
        sku: 'PROJ-CR-004',
      },
    ],
    totalAmount: 799.99,
    status: 'shipped',
    paymentStatus: 'paid',
    paymentMethod: 'Bank Transfer',
    shippingAddress: {
      street: '100 Corporate Way',
      city: 'New York',
      state: 'NY',
      zip: '10001',
      country: 'USA',
    },
    specialInstructions: 'Deliver to 3rd floor reception',
    timestamps: {
      pending: '2025-06-12T07:00:00Z',
      processing: '2025-06-12T11:30:00Z',
      shipped: '2025-06-13T10:00:00Z',
    },
  },
  {
    id: '5',
    orderId: 'WO-78455',
    retailerName: 'Modern Retail Co.',
    retailerEmail: 'support@modernretail.com',
    products: [
      {
        id: 'p6',
        name: 'Retail Barcode Scanner',
        quantity: 5,
        price: 89.99,
        sku: 'RBS-STD-005',
      },
    ],
    totalAmount: 449.95,
    status: 'delivered',
    paymentStatus: 'paid',
    paymentMethod: 'Credit Card',
    shippingAddress: {
      street: '202 Retail Park',
      city: 'Phoenix',
      state: 'AZ',
      zip: '85001',
      country: 'USA',
    },
    specialInstructions: '',
    timestamps: {
      pending: '2025-06-09T08:00:00Z',
      processing: '2025-06-09T10:45:00Z',
      shipped: '2025-06-10T13:20:00Z',
      delivered: '2025-06-12T16:30:00Z',
    },
  },
  {
    id: '6',
    orderId: 'WO-78456',
    retailerName: 'GadgetZone',
    retailerEmail: 'sales@gadgetzone.com',
    products: [
      {
        id: 'p7',
        name: 'Bluetooth Headset',
        quantity: 10,
        price: 49.99,
        sku: 'BT-HS-BLK-006',
      },
    ],
    totalAmount: 499.9,
    status: 'cancelled',
    paymentStatus: 'refunded',
    paymentMethod: 'UPI',
    shippingAddress: {
      street: '88 Tech Street',
      city: 'Seattle',
      state: 'WA',
      zip: '98101',
      country: 'USA',
    },
    specialInstructions: 'Customer canceled due to delay',
    timestamps: {
      pending: '2025-06-08T09:00:00Z',
      cancelled: '2025-06-08T12:15:00Z',
    },
  },
  {
    id: '7',
    orderId: 'WO-78457',
    retailerName: 'Urban Electronics',
    retailerEmail: 'urban@electronics.com',
    products: [
      {
        id: 'p8',
        name: 'Wireless Router',
        quantity: 4,
        price: 119.99,
        sku: 'WR-AC-007',
      },
    ],
    totalAmount: 479.96,
    status: 'processing',
    paymentStatus: 'paid',
    paymentMethod: 'Debit Card',
    shippingAddress: {
      street: '310 Network Lane',
      city: 'Denver',
      state: 'CO',
      zip: '80014',
      country: 'USA',
    },
    specialInstructions: 'Install on delivery if possible',
    timestamps: {
      pending: '2025-06-16T08:10:00Z',
      processing: '2025-06-16T12:45:00Z',
    },
  },
];

const statusVariants = {
  delivered: 'success',
  processing: 'info',
  pending: 'warning',
  shipped: 'primary',
  cancelled: 'error',
};

const paymentVariants = {
  paid: 'success',
  pending: 'warning',
  failed: 'error',
};

const products = [
  {
    id: '1',
    name: 'Modular Switch Plate with 6A Switches',
    category: 'Electrical Fittings',
    basePrice: 180,
    sellerPrice: 200,
    mrp: 250,
    status: 'active',
    images: [
      'https://m.media-amazon.com/images/I/61nD6vO9jFL.jpg',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTPL2IQQhoEAR3iyTUuDt8jJlHMEhn6fwE1X4J26xdLnR9Wfc1gCZXI2gFZ-4zXFydFypg&usqp=CAU',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQh9WIVOdA6HpoXaqSBYECUxY5hsqV4KoywPz3CkVssKKttnYW7c--i72DzqlwKfOcseGg&usqp=CAU',
    ],
  },
  {
    id: '2',
    name: 'Adjustable Wall-Mounted Cable Trunking',
    category: 'Electrical Fittings',
    basePrice: 450,
    sellerPrice: 500,
    mrp: 599,
    status: 'active',
    images: [
      'https://mccoymart.com/buy_catalog/image/catalog/products/2023/09/Azzuro-QZR-3101LB.webp',
      'https://mccoymart.com/buy_catalog/image/catalog/products/2024/12/F1018401FG.webp',
    ],
  },
  {
    id: '3',
    name: 'Heavy-Duty Extension Cord with Surge Protection',
    category: 'Electronics',
    basePrice: 90,
    sellerPrice: 100,
    mrp: 129,
    status: 'active',
    images: [
      'https://images.unsplash.com/photo-1510070009289-b5bc34383727',
      'https://images.unsplash.com/photo-1580894894514-1c473225e155',
    ],
  },
  {
    id: '4',
    name: 'Slimline Modular Switch 16A - ISI Approved',
    category: 'Electrical Fittings',
    basePrice: 90,
    sellerPrice: 100,
    mrp: 119,
    status: 'draft',
    images: ['https://images.unsplash.com/photo-1587829741301-dc798b83add3'],
  },
  {
    id: '5',
    name: 'Rechargeable LED Surface Panel Light 12W',
    category: 'Lighting',
    basePrice: 45,
    sellerPrice: 50,
    mrp: 65,
    status: 'active',
    images: ['https://images.unsplash.com/photo-1582719478174-72f2271ffb3f'],
  },
  {
    id: '6',
    name: 'Wireless Doorbell Switch - Waterproof',
    category: 'Electrical Accessories',
    basePrice: 22,
    sellerPrice: 25,
    mrp: 35,
    status: 'archived',
    images: ['https://images.unsplash.com/photo-1612902371945-7a6c6d3de15c'],
  },
  {
    id: '7',
    name: 'Multi-Purpose Screwdriver Set - 6 in 1',
    category: 'Hand Tools',
    basePrice: 18,
    sellerPrice: 20,
    mrp: 25,
    status: 'active',
    images: ['https://images.unsplash.com/photo-1611078489935-ec717e3c1575'],
  },
];

const initialUsers = [
  {
    id: 1,
    name: 'Alice Johnson',
    email: 'alice@example.com',
    phone: '9876543210',
    isActive: true,
    createdAt: '2023-12-01T12:00:00Z',
  },
  {
    id: 2,
    name: 'Bob Smith',
    email: 'bob@example.com',
    phone: '9123456789',
    isActive: false,
    createdAt: '2024-01-15T09:30:00Z',
  },
  {
    id: 3,
    name: 'Charlie Brown',
    email: 'charlie@example.com',
    phone: '9301234567',
    isActive: true,
    createdAt: '2024-02-05T10:00:00Z',
  },
  {
    id: 4,
    name: 'David Wilson',
    email: 'david@example.com',
    phone: '9012345678',
    isActive: true,
    createdAt: '2024-03-02T14:00:00Z',
  },
  {
    id: 5,
    name: 'Eva Martinez',
    email: 'eva@example.com',
    phone: '9123456780',
    isActive: true,
    createdAt: '2024-01-28T08:30:00Z',
  },
  {
    id: 6,
    name: 'Frank Harris',
    email: 'frank@example.com',
    phone: '9309876543',
    isActive: false,
    createdAt: '2024-03-15T11:15:00Z',
  },
  {
    id: 7,
    name: 'Grace Lee',
    email: 'grace@example.com',
    phone: '9234567890',
    isActive: true,
    createdAt: '2024-04-10T16:20:00Z',
  },
  {
    id: 8,
    name: 'Henry King',
    email: 'henry@example.com',
    phone: '9012345679',
    isActive: true,
    createdAt: '2024-05-02T12:45:00Z',
  },
  {
    id: 9,
    name: 'Ivy Green',
    email: 'ivy@example.com',
    phone: '9456789012',
    isActive: false,
    createdAt: '2024-04-18T09:00:00Z',
  },
  {
    id: 10,
    name: 'Jack Turner',
    email: 'jack@example.com',
    phone: '9098765432',
    isActive: false,
    createdAt: '2024-03-22T13:00:00Z',
  },
  {
    id: 11,
    name: 'Karen Scott',
    email: 'karen@example.com',
    phone: '9223456789',
    isActive: true,
    createdAt: '2024-02-20T17:30:00Z',
  },
  {
    id: 12,
    name: 'Leo Patel',
    email: 'leo@example.com',
    phone: '9112233445',
    isActive: true,
    createdAt: '2024-01-25T08:45:00Z',
  },
];
const dummyLogs = [
  {
    productName: 'Air Max 90',
    oldPrice: 3999.99,
    newPrice: 4499.99,
    changedBy: 'John Doe',
    changedAt: '2024-11-01T10:30:00',
  },
  {
    productName: 'Nike Blazer',
    oldPrice: 2999.99,
    newPrice: 2499.99,
    changedBy: 'Jane Smith',
    changedAt: '2024-11-02T14:15:00',
  },
  {
    productName: 'Adidas Ultraboost',
    oldPrice: 5999.99,
    newPrice: 6499.99,
    changedBy: 'Ravi Kumar',
    changedAt: '2024-11-03T08:45:00',
  },
  {
    productName: 'Puma RS-X',
    oldPrice: 3499.99,
    newPrice: 3299.99,
    changedBy: 'Sneha Rao',
    changedAt: '2024-11-04T12:20:00',
  },
  {
    productName: 'Reebok Classic',
    oldPrice: 2799.99,
    newPrice: 2999.99,
    changedBy: 'Anil Mehta',
    changedAt: '2024-11-05T15:10:00',
  },
  {
    productName: 'Vans Old Skool',
    oldPrice: 3299.99,
    newPrice: 3099.99,
    changedBy: 'Meera Nair',
    changedAt: '2024-11-06T11:45:00',
  },
  {
    productName: 'New Balance 574',
    oldPrice: 3899.99,
    newPrice: 4099.99,
    changedBy: 'Arjun Singh',
    changedAt: '2024-11-07T13:00:00',
  },
  {
    productName: 'Asics Gel-Lyte III',
    oldPrice: 4599.99,
    newPrice: 4399.99,
    changedBy: 'Divya Sharma',
    changedAt: '2024-11-08T09:25:00',
  },
  {
    productName: 'Converse Chuck Taylor',
    oldPrice: 2499.99,
    newPrice: 2699.99,
    changedBy: 'Vikram Joshi',
    changedAt: '2024-11-09T10:50:00',
  },
  {
    productName: 'Fila Disruptor II',
    oldPrice: 3199.99,
    newPrice: 2899.99,
    changedBy: 'Pooja Reddy',
    changedAt: '2024-11-10T16:35:00',
  },
  {
    productName: 'Under Armour Charged',
    oldPrice: 3999.99,
    newPrice: 4199.99,
    changedBy: 'Tarun Kapoor',
    changedAt: '2024-11-11T12:40:00',
  },
  {
    productName: 'Skechers D’Lites',
    oldPrice: 2899.99,
    newPrice: 2699.99,
    changedBy: 'Neha Kulkarni',
    changedAt: '2024-11-12T14:05:00',
  },
  {
    productName: 'Jordan 1 Mid',
    oldPrice: 7999.99,
    newPrice: 8499.99,
    changedBy: 'Ajay Bhatt',
    changedAt: '2024-11-13T17:15:00',
  },
  {
    productName: 'Yeezy Boost 350',
    oldPrice: 11999.99,
    newPrice: 11499.99,
    changedBy: 'Sara Ali',
    changedAt: '2024-11-14T11:00:00',
  },
  {
    productName: 'Crocs Classic Clog',
    oldPrice: 1999.99,
    newPrice: 2199.99,
    changedBy: 'Ramesh Babu',
    changedAt: '2024-11-15T10:10:00',
  },
];
const dummyPermissions = [
  { id: 1, action: 'create_product', allowed: true },
  { id: 2, action: 'edit_product', allowed: false },
  { id: 3, action: 'delete_product', allowed: false },
  { id: 4, action: 'view_products', allowed: true },
  { id: 5, action: 'view_orders', allowed: true },
  { id: 6, action: 'update_order_status', allowed: false },
  { id: 7, action: 'cancel_order', allowed: false },
  { id: 8, action: 'view_customers', allowed: true },
  { id: 9, action: 'export_customer_data', allowed: false },
  { id: 10, action: 'update_pricing', allowed: false },
  { id: 11, action: 'view_price_history', allowed: true },
  { id: 12, action: 'apply_discounts', allowed: false },
  { id: 13, action: 'view_sales_reports', allowed: true },
  { id: 14, action: 'view_inventory_reports', allowed: false },
  { id: 15, action: 'export_reports', allowed: false },
];
const dummyVerifications = [
  {
    id: 'v1',
    sellerId: 's123',
    sellerName: 'John Doe',
    status: 'pending',
    submittedAt: '2024-10-01T10:00:00Z',
    documents: ['https://example.com/doc1.pdf', 'https://example.com/doc2.pdf'],
  },
  {
    id: 'v2',
    sellerId: 's456',
    sellerName: 'Jane Smith',
    status: 'approved',
    submittedAt: '2024-09-25T14:30:00Z',
    documents: ['https://example.com/doc3.pdf'],
  },
];

const notifications = [
  {
    label: '🔔 New order received',
    route: '/latest-orders', // 👈 Route to navigate
  },
  {
    label: '🛠️ System update at 10 PM',
    route: null, // No redirection
  },
  {
    label: '💬 New message from Admin',
    route: '/seller/messages',
  },
];
const initialOrders = [
  {
    id: 'ORD1234',
    customer: 'John Doe',
    items: 3,
    amount: 1200,
    time: '10 mins ago',
    status: 'pending',
  },
  {
    id: 'ORD1235',
    customer: 'AC Corp',
    items: 1,
    amount: 550,
    time: '25 mins ago',
    status: 'pending',
  },
  {
    id: 'ORD1236',
    customer: 'Jane Smith',
    items: 5,
    amount: 2300,
    time: '40 mins ago',
    status: 'pending',
  },
];

const statusColors = {
  pending: 'bg-yellow-100 text-yellow-800',
  accepted: 'bg-green-100 text-green-800',
  denied: 'bg-red-100 text-red-800',
};
const dummyBrands = ['Havells', 'Anchor', 'Philips', 'Syska', 'Schneider Electric', 'Legrand'];
const brandProducts = [
  {
    name: 'Smart LED Bulb',
    price: '₹499',
    image: 'https://via.placeholder.com/150x100.png?text=Smart+LED+Bulb',
  },
  {
    name: 'Energy Efficient Wire',
    price: '₹1499',
    image: 'https://via.placeholder.com/150x100.png?text=Efficient+Wire',
  },
  {
    name: 'WiFi Smart Switch',
    price: '₹799',
    image: 'https://via.placeholder.com/150x100.png?text=Smart+Switch',
  },
];

const categories = ['Switches', 'Wires', 'LED Lights', 'Smart Devices', 'Surge Protectors'];
const sellernotification = [
  {
    id: 1,
    orderId: 'ORD789321',
    customer: 'Alex Carter',
    status: 'Pending',
    time: 'Just now',
    icon: <Loader className="text-yellow-500" />,
  },
  {
    id: 2,
    orderId: 'ORD789322',
    customer: 'Megan Ray',
    status: 'Accepted',
    time: '5 mins ago',
    icon: <CheckCircle className="text-green-500" />,
  },
  {
    id: 3,
    orderId: 'ORD789323',
    customer: 'Lucas White',
    status: 'Cancelled',
    time: '30 mins ago',
    icon: <XCircle className="text-red-500" />,
  },
];
const productlistdata = [
  {
    id: '101',
    productName: 'Wireless Ergonomic Mouse',
    sku: 'WEM-BLK-101',
    stock: 5,
    maxStock: 200,
    unitPrice: 49.99,
    category: 'Computer Accessories',
    description: 'An ergonomically designed wireless mouse for improved comfort and productivity.',
    lastRestocked: 'May 20, 2025',
    images: [
      'https://m.media-amazon.com/images/I/61LtuGzXeaL._AC_SL1500_.jpg',
      'https://m.media-amazon.com/images/I/61LtuGzXeaL._AC_SL1000_.jpg',
      'https://m.media-amazon.com/images/I/61LtuGzXeaL._AC_SL1200_.jpg',
    ],
  },
  {
    id: '102',
    productName: 'LED Desk Lamp',
    sku: 'LDL-SLV-102',
    stock: 0,
    maxStock: 75,
    unitPrice: 79.99,
    category: 'Office Supplies',
    description: 'A sleek LED desk lamp with adjustable brightness and color temperature settings.',
    lastRestocked: 'May 15, 2025',
    images: [
      'https://m.media-amazon.com/images/I/71mHBc5m9qL._AC_SL1500_.jpg',
      'https://m.media-amazon.com/images/I/71mHBc5m9qL._AC_SL1000_.jpg',
      'https://m.media-amazon.com/images/I/71mHBc5m9qL._AC_SL1200_.jpg',
    ],
  },
  {
    id: '103',
    productName: '4K Ultra HD Monitor',
    sku: 'UHD-27-103',
    stock: 1,
    maxStock: 30,
    unitPrice: 399.99,
    category: 'Electronics',
    description: 'A 27-inch 4K UHD monitor offering stunning visuals and vibrant color accuracy.',
    lastRestocked: 'May 18, 2025',
    images: [
      'https://m.media-amazon.com/images/I/61Gz0Qf3YtL._AC_SL1500_.jpg',
      'https://m.media-amazon.com/images/I/61Gz0Qf3YtL._AC_SL1200_.jpg',
      'https://m.media-amazon.com/images/I/61Gz0Qf3YtL._AC_SL1000_.jpg',
    ],
  },
  {
    id: '104',
    productName: 'Office Filing Cabinet',
    sku: 'OFC-3D-104',
    stock: 15,
    maxStock: 60,
    unitPrice: 149.99,
    category: 'Office Furniture',
    description: 'A durable 3-drawer metal filing cabinet for efficient document storage.',
    lastRestocked: 'May 22, 2025',
    images: [
      'https://m.media-amazon.com/images/I/81rkRylWiBL._AC_SL1500_.jpg',
      'https://m.media-amazon.com/images/I/81rkRylWiBL._AC_SL1200_.jpg',
      'https://m.media-amazon.com/images/I/81rkRylWiBL._AC_SL1000_.jpg',
    ],
  },
  {
    id: '105',
    productName: 'Noise Cancelling Headphones',
    sku: 'NCH-OE-105',
    stock: 25,
    maxStock: 100,
    unitPrice: 129.99,
    category: 'Electronics',
    description: 'Over-ear headphones with advanced noise cancellation and superior sound quality.',
    lastRestocked: 'May 21, 2025',
    images: [
      'https://m.media-amazon.com/images/I/71gvMT8iATL._AC_SL1500_.jpg',
      'https://m.media-amazon.com/images/I/71gvMT8iATL._AC_SL1200_.jpg',
      'https://m.media-amazon.com/images/I/71gvMT8iATL._AC_SL1000_.jpg',
    ],
  },
  {
    id: '106',
    productName: 'USB-C Hub Multiport Adapter',
    sku: 'USB-HUB-106',
    stock: 10,
    maxStock: 120,
    unitPrice: 59.99,
    category: 'Computer Accessories',
    description: 'A compact USB-C hub offering multiple ports for enhanced connectivity.',
    lastRestocked: 'May 19, 2025',
    images: [
      'https://m.media-amazon.com/images/I/61ZsI9GbA+L._AC_SL1500_.jpg',
      'https://m.media-amazon.com/images/I/61ZsI9GbA+L._AC_SL1000_.jpg',
      'https://m.media-amazon.com/images/I/61ZsI9GbA+L._AC_SL1200_.jpg',
    ],
  },
  {
    id: '107',
    productName: 'Executive Leather Chair',
    sku: 'ELC-BRN-107',
    stock: 100,
    maxStock: 40,
    unitPrice: 299.99,
    category: 'Office Furniture',
    description: 'A high-back leather executive chair providing maximum comfort and support.',
    lastRestocked: 'May 23, 2025',
    images: [
      'https://m.media-amazon.com/images/I/71lrhpgQ+7L._AC_SL1500_.jpg',
      'https://m.media-amazon.com/images/I/71lrhpgQ+7L._AC_SL1200_.jpg',
      'https://m.media-amazon.com/images/I/71lrhpgQ+7L._AC_SL1000_.jpg',
    ],
  },
  {
    id: '108',
    productName: 'Wireless Keyboard',
    sku: 'WK-CPT-108',
    stock: 60,
    maxStock: 150,
    unitPrice: 69.99,
    category: 'Computer Accessories',
    description: 'A slim wireless keyboard with silent keys and long battery life.',
    lastRestocked: 'May 20, 2025',
    images: [
      'https://m.media-amazon.com/images/I/71RbC1Wi0kL._AC_SL1500_.jpg',
      'https://m.media-amazon.com/images/I/71RbC1Wi0kL._AC_SL1000_.jpg',
      'https://m.media-amazon.com/images/I/71RbC1Wi0kL._AC_SL1200_.jpg',
    ],
  },
  {
    id: '109',
    productName: 'High-Speed HDMI Cable',
    sku: 'HDMI-2M-109',
    stock: 100,
    maxStock: 300,
    unitPrice: 12.99,
    category: 'Electronics',
    description:
      'A 2-meter high-speed HDMI cable supporting 4K resolution and audio return channel.',
    lastRestocked: 'May 22, 2025',
    images: [
      'https://m.media-amazon.com/images/I/61VIZQSu1BL._AC_SL1500_.jpg',
      'https://m.media-amazon.com/images/I/61VIZQSu1BL._AC_SL1000_.jpg',
      'https://m.media-amazon.com/images/I/61VIZQSu1BL._AC_SL1200_.jpg',
    ],
  },
  {
    id: '110',
    productName: 'Desktop Organizer',
    sku: 'DO-WD-110',
    stock: 40,
    maxStock: 80,
    unitPrice: 39.99,
    category: 'Office Supplies',
    description: 'A wooden desktop organizer with compartments for documents and accessories.',
    lastRestocked: 'May 19, 2025',
    images: [
      'https://m.media-amazon.com/images/I/71EDl29ZKVL._AC_SL1500_.jpg',
      'https://m.media-amazon.com/images/I/71EDl29ZKVL._AC_SL1000_.jpg',
      'https://m.media-amazon.com/images/I/71EDl29ZKVL._AC_SL1200_.jpg',
    ],
  },
];

const productHistoryData = [
  {
    productId: '101',
    date: 'May 25, 2025',
    modifiedBy: 'Admin',
    changes: [
      { field: 'Unit Price', before: '₹49.99', after: '₹54.99' },
      { field: 'Stock', before: '5', after: '25' },
    ],
    note: 'Price and stock updated after supplier revision.',
  },
  {
    productId: '102',
    date: 'May 26, 2025',
    modifiedBy: 'Inventory Manager',
    changes: [
      {
        field: 'Description',
        before: 'A reusable water bottle made from sustainable materials.',
        after: 'A stylish LED lamp with adjustable brightness.',
      },
    ],
    note: 'Corrected description.',
  },
  {
    productId: '103',
    date: 'May 28, 2025',
    modifiedBy: 'Admin',
    changes: [{ field: 'Stock', before: '1', after: '10' }],
    note: 'Stock increased due to high demand.',
  },
  {
    productId: '104',
    date: 'March 28, 2025',
    modifiedBy: 'Admin',
    changes: [{ field: 'Stock', before: '15', after: '20' }],
    note: 'Stock adjusted.',
  },
  {
    productId: '105',
    date: 'May 27, 2025',
    modifiedBy: 'Warehouse',
    changes: [{ field: 'Unit Price', before: '₹129.99', after: '₹119.99' }],
    note: 'Price dropped for summer sale.',
  },
  {
    productId: '106',
    date: 'May 29, 2025',
    modifiedBy: 'Procurement',
    changes: [{ field: 'Stock', before: '10', after: '50' }],
    note: 'Stock increased.',
  },
  {
    productId: '107',
    date: 'May 30, 2025',
    modifiedBy: 'Admin',
    changes: [
      { field: 'Max Stock', before: '40', after: '120' },
      { field: 'Stock', before: '100', after: '80' },
    ],
    note: 'Updated max stock after warehouse capacity review.',
  },
  {
    productId: '108',
    date: 'May 29, 2025',
    modifiedBy: 'Manager',
    changes: [
      {
        field: 'Description',
        before: 'A reusable water bottle made from sustainable materials.',
        after: 'A compact wireless keyboard with long battery life.',
      },
    ],
    note: 'Updated product description.',
  },
];
const registeredSellers = [
  {
    id: 1,
    name: 'John Doe',
    email: 'john@example.com',
    registrationDate: '2025-05-01',
  },
  {
    id: 2,
    name: 'Jane Smith',
    email: 'jane@example.com',
    registrationDate: '2025-04-15',
  },
  {
    id: 3,
    name: 'Alex Johnson',
    email: 'alex@example.com',
    registrationDate: '2025-03-30',
  },
  {
    id: 4,
    name: 'Priya Mehta',
    email: 'priya@example.com',
    registrationDate: '2025-02-20',
  },
];
const sellerSalesData = {
  1: {
    name: 'John Doe',
    sold: 420,
    brandName: 'Bright Spark',
    tradeName: 'BrightSpark Pvt Ltd',
    gstNumber: '29ABCDE1234F2Z5',
    gstCertificate: 'https://example.com/certificates/john-doe-gst.pdf',
    address: '12 MG Road, Bangalore, Karnataka, India',
    note: 'Top seller in the northern region.',
  },
  2: {
    name: 'Jane Smith',
    sold: 320,
    brandName: 'Eco Lite',
    tradeName: 'EcoLite Solutions',
    gstNumber: '07XYZAB1234L1Z2',
    gstCertificate: 'https://example.com/certificates/jane-smith-gst.pdf',
    address: '5 Green Park, New Delhi, India',
    note: 'Consistently meets targets with sustainable products.',
  },
  3: {
    name: 'Alex Johnson',
    sold: 60,
    brandName: 'VoltMax',
    tradeName: 'VoltMax Power Tools',
    gstNumber: '27PQRLM5678K9Z3',
    gstCertificate: 'https://example.com/certificates/alex-johnson-gst.pdf',
    address: '201 Industrial Area, Pune, Maharashtra',
    note: 'Focused on high-power tools segment.',
  },
  4: {
    name: 'Priya Mehta',
    sold: 0,
    brandName: 'LiteGlow',
    tradeName: 'LiteGlow Enterprises',
    gstNumber: '19MNBVC2345H1Z8',
    gstCertificate: 'https://example.com/certificates/priya-mehta-gst.pdf',
    address: '88 Prince Anwar Shah Road, Kolkata, India',
    note: 'Newly onboarded seller.',
  },
};
const sellerProductSalesData = [
  {
    sellerId: '1',
    name: 'Wireless Mouse',
    category: 'Electronics',
    unitsSold: 240,
  },
  {
    sellerId: '1',
    name: 'Keyboard',
    category: 'Electronics',
    unitsSold: 180,
  },
  {
    sellerId: '2',
    name: 'Running Shoes',
    category: 'Footwear',
    unitsSold: 320,
  },
  {
    sellerId: '3',
    name: 'mouse',
    category: 'Electronics',
    unitsSold: 60,
  },
];
const brandlist = [
  {
    id: '1',
    name: 'Modular Switch Plate with 6A Switches',
    brandName: 'Anchor',
    category: 'Electrical Fittings',
    basePrice: 180,
    sellerPrice: 200,
    mrp: 250,
    status: 'active',
    images: [
      'https://m.media-amazon.com/images/I/61nD6vO9jFL.jpg',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTPL2IQQhoEAR3iyTUuDt8jJlHMEhn6fwE1X4J26xdLnR9Wfc1gCZXI2gFZ-4zXFydFypg&usqp=CAU',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQh9WIVOdA6HpoXaqSBYECUxY5hsqV4KoywPz3CkVssKKttnYW7c--i72DzqlwKfOcseGg&usqp=CAU',
    ],
  },
  {
    id: '2',
    name: 'Adjustable Wall-Mounted Cable Trunking',
    brandName: 'Finolex',
    category: 'Electrical Fittings',
    basePrice: 450,
    sellerPrice: 500,
    mrp: 599,
    status: 'active',
    images: [
      'https://mccoymart.com/buy_catalog/image/catalog/products/2023/09/Azzuro-QZR-3101LB.webp',
      'https://mccoymart.com/buy_catalog/image/catalog/products/2024/12/F1018401FG.webp',
    ],
  },
  {
    id: '3',
    name: 'Heavy-Duty Extension Cord with Surge Protection',
    brandName: 'Syska',
    category: 'Electronics',
    basePrice: 90,
    sellerPrice: 100,
    mrp: 129,
    status: 'active',
    images: [
      'https://images.unsplash.com/photo-1510070009289-b5bc34383727',
      'https://images.unsplash.com/photo-1580894894514-1c473225e155',
    ],
  },
  {
    id: '4',
    name: 'Slimline Modular Switch 16A - ISI Approved',
    brandName: 'GM',
    category: 'Electrical Fittings',
    basePrice: 90,
    sellerPrice: 100,
    mrp: 119,
    status: 'draft',
    images: ['https://images.unsplash.com/photo-1587829741301-dc798b83add3'],
  },
  {
    id: '5',
    name: 'Rechargeable LED Surface Panel Light 12W',
    brandName: 'Philips',
    category: 'Lighting',
    basePrice: 45,
    sellerPrice: 50,
    mrp: 65,
    status: 'active',
    images: ['https://images.unsplash.com/photo-1582719478174-72f2271ffb3f'],
  },
  {
    id: '6',
    name: 'Wireless Doorbell Switch - Waterproof',
    brandName: 'Panasonic',
    category: 'Electrical Accessories',
    basePrice: 22,
    sellerPrice: 25,
    mrp: 35,
    status: 'archived',
    images: ['https://images.unsplash.com/photo-1612902371945-7a6c6d3de15c'],
  },
  {
    id: '7',
    name: 'Multi-Purpose Screwdriver Set - 6 in 1',
    brandName: 'Taparia',
    category: 'Hand Tools',
    basePrice: 18,
    sellerPrice: 20,
    mrp: 25,
    status: 'active',
    images: ['https://images.unsplash.com/photo-1611078489935-ec717e3c1575'],
  },
];
const brandDummyData = {
  role: 'brand',
  brandName: 'GlowTech Industries',
  tradeName: 'GlowTech',
  pocName: 'Anita Sharma',
  pocMobile: '9876543210',
  gstNumber: '27ABCDE1234F1Z5',
  gstCertificate: 'https://example.com/certificates/glowtech-gst.pdf',
  brandLogo:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQZRZkUIR61y08pwhlHv0GWNyaS7bHQgwnStg&s',
};

const sellerDummyData = {
  role: 'seller',
  sellerName: 'TechMart Wholesale',
  ownerName: 'Rohit Mehra',
  address: '5 Green Park, New Delhi, India',
  gstNumber: '29ABCDE4321Z9X',
  gstCertificate: 'https://example.com/certificates/techmart-gst.pdf',
};

export {
  topSellingProducts,
  dummyProducts,
  mockLogs,
  SellerNames,
  brandsMock,
  dummyTopProducts,
  statCards,
  revenueY,
  months,
  barHeights,
  linePoints,
  lineYCoords,
  productColumns,
  topProducts,
  inventoryItemsData,
  ordersdata,
  statusVariants,
  paymentVariants,
  products,
  initialUsers,
  dummyLogs,
  dummyPermissions,
  dummyVerifications,
  notifications,
  initialOrders,
  statusColors,
  dummyBrands,
  brandProducts,
  categories,
  sellernotification,
  productlistdata,
  registeredSellers,
  sellerSalesData,
  productHistoryData,
  sellerProductSalesData,
  brandlist,
  brandDummyData,
  sellerDummyData,
};
